import { useState } from "react";
import { Link } from "react-router-dom";
import Pagination from "@/components/base/Pagination";
import EmptyState from "@/components/base/EmptyState";
import { allNews, getLatestNews, paginate } from "@/utils/media";
import { useSeo } from "@/hooks/useSeo";

const PAGE_SIZE = 6;

export default function NewsList() {
  const [page, setPage] = useState(1);
  const sorted = getLatestNews(allNews.length);
  const result = paginate(sorted, page, PAGE_SIZE);

  useSeo({
    title: "影视资讯 - 91影视",
    description: "91影视资讯频道，提供影视行业动态、档期信息、剧集观察与影评推荐等丰富内容。",
    keywords: "91影视,影视资讯,影视新闻,影评推荐,行业观察",
  });

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-8 md:py-10">
      <nav className="flex items-center gap-2 text-sm text-foreground-500" aria-label="面包屑">
        <Link to="/" className="transition-colors hover:text-primary-600">
          首页
        </Link>
        <i className="ri-arrow-right-s-line"></i>
        <span className="text-foreground-900">影视资讯</span>
      </nav>

      <header className="mt-4">
        <h1 className="text-2xl font-extrabold text-foreground-950 md:text-3xl">影视资讯</h1>
        <p className="mt-2 max-w-2xl text-sm text-foreground-500">
          汇聚影视行业动态、剧集观察与影评推荐，帮助你了解最新影视内容与趋势。
        </p>
      </header>

      <div className="mt-6">
        {result.items.length > 0 ? (
          <div className="space-y-4">
            {result.items.map((item) => (
              <Link
                key={item.id}
                to={`/news/${item.id}`}
                className="group flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 sm:flex-row"
              >
                <div className="h-40 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-28 sm:w-44">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} - 91影视资讯`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col justify-center">
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="rounded bg-accent-100 px-2 py-0.5 font-medium text-accent-700">
                      {item.category}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {item.date}
                    </span>
                  </div>
                  <h2 className="mt-2 text-base font-bold text-foreground-950 group-hover:text-primary-600">
                    {item.title}
                  </h2>
                  <p className="mt-1.5 line-clamp-2 text-sm text-foreground-500">{item.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <EmptyState
            icon="ri-newspaper-line"
            title="暂无影视资讯"
            description="当前没有可显示的资讯内容，返回首页看看其他内容吧。"
            actionLabel="返回首页"
            to="/"
          />
        )}
      </div>

      <Pagination page={result.page} totalPages={result.totalPages} onChange={setPage} />
    </div>
  );
}